module.exports = __webpack_public_path__ + "static/media/redTick.d8595f2e.png";